import { render } from "./AdminCityList.vue?vue&type=template&id=ba35723c&ts=true&lang=true"
import script from "./AdminCityList.vue?vue&type=script&lang=ts"
export * from "./AdminCityList.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__